import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import SectionHomes from './SectionHomes';
import SectionDescription from './SectionDescription';
import SectionSchools from './SectionSchools';
// import SectionDirections from './SectionDirections';
import SectionPlatMap from './SectionPlatMap';
import SectionBuilders from './SectionBuilders';
import SectionFeatures from './SectionFeatures';
import SectionLogos from './SectionLogos';

const styles = css`
  padding: 43px 0 63px;
  background-color: #000000;
  @media (max-width: 767.98px) {
    .AccordionToggle_contentWrapper {
    }
  }
  .AccordionToggle_content {
    padding: 36px 20px 48px;
  }
  @media (min-width: 768px) {
    padding: 52px 40px 125px;
    margin: 0;
    .AccordionToggle_content {
      padding: 0;
    }
    .Accordion_section {
      &:not(:last-child) {
        margin-bottom: 52px;
      }
    }
  }
  @media (min-width: 992px) {
    padding: 50px 90px 165px;
    .Accordion_inner {
      max-width: 1140px;
      margin: 0 auto;
    }
    .Accordion_section:not(:last-child) {
      margin-bottom: 57px;
    }
  }
  .AccordionToggle_scrollTarget {
    @media (min-width: 768px) {
      margin-top: -60px;
    }
  }
`;


function Accordion({ community, homes }) {
  return (
    <div className={styles}>
      <div className="Accordion_inner">
        <SectionPlatMap
          className="Accordion_section"
          community={community}
        />
        {
          homes.length > 0 &&
          <SectionHomes
            className="Accordion_section"
            community={community}
          />
        }
        {
          get(community, 'description') &&
          <SectionDescription
            community={community}
          />
        }
        {
          get(community, 'features').length > 0 &&
          get(community, 'features[0].bullet_points') &&
          get(community, 'features[0].bullet_points').length > 0 &&
          <SectionFeatures
            className="Accordion_section"
            community={community}
          />
        }
        {
          community.approved_builders && community.approved_builders.length > 0 &&
          <SectionBuilders
            className="Accordion_section"
            community={community}
          />
        }
        {
          get(community, 'schools', []) && get(community, 'schools', []).length > 0 &&
          <SectionSchools
            className="Accordion_section"
            community={community}
          />
        }
        <SectionLogos
          className="Accordion_section"
          community={community}
        />
        {/* <SectionDirections
          className="Accordion_section"
          marker={{
            geoIndexed: get(community, 'geoIndexed'),
            _id: get(community, '_id'),
          }}
          directions={get(community, 'directions', '')}
        /> */}
      </div>
    </div>
  );
}

Accordion.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
};

Accordion.defaultProps = {
  homes: [],
};

export default withData({
  community: true,
  homes: true,
})(Accordion);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Accordion.js